import React from 'react';

const stroke = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.75, strokeLinecap: 'round', strokeLinejoin: 'round' };

/**
 * Embroidery / textile mill themed icons for the main production workflow.
 */
export function ProductionWorkflowGlyph({ stage, className }) {
  const c = className || 'h-7 w-7';
  switch (stage) {
    case 'APPROVED':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M7 4h10a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2z" />
          <path {...stroke} d="M8 8c2 1 3 1 5 0M8 12h8M8 16h5" />
          <path {...stroke} d="M16.5 17.5l1.5 1.5 3-3" />
        </svg>
      );
    case 'PLACE_ORDER':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <ellipse {...stroke} cx="12" cy="7" rx="5" ry="2.5" />
          <path {...stroke} d="M7 7v3c0 2.5 5 2.5 5 0V7M12 9.5v8" />
          <path {...stroke} d="M9 20h6M10 17h4" />
        </svg>
      );
    case 'IN_PRODUCTION':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <rect {...stroke} x="5" y="6" width="14" height="12" rx="1.5" />
          <path {...stroke} d="M8 6V4M12 6V4M16 6V4" />
          <path {...stroke} d="M8 9v6M10 9v6M12 9v6M14 9v6M16 9v6" />
          <path {...stroke} d="M7 18h10" />
        </svg>
      );
    case 'PRODUCTION_DONE':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M6 10c0-3 3.5-5 6-3 2.5-2 6 0 6 3v6c-2-1.5-4-2-6-2s-4 .5-6 2v-6z" />
          <path {...stroke} d="M9 14l2 2 4-4" />
        </svg>
      );
    case 'READY_FOR_DISPATCH':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M5 10l7-4 7 4v8l-7 4-7-4V10z" />
          <path {...stroke} d="M12 6v16M5 10l7 4 7-4" />
        </svg>
      );
    case 'DISPATCHED':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M3 7h12v10H3zM15 10h4l2 3v4h-6" />
          <circle {...stroke} cx="7.5" cy="18.5" r="1.5" />
          <circle {...stroke} cx="17" cy="18.5" r="1.5" />
          <path {...stroke} d="M6 7V5a2 2 0 012-2h6l3 4" />
        </svg>
      );
    case 'DELIVERED':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M4 10l8-6 8 6v10a1 1 0 01-1 1h-5v-6H10v6H5a1 1 0 01-1-1V10z" />
          <path {...stroke} d="M9 21V12h6v9" />
        </svg>
      );
    default:
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <circle {...stroke} cx="12" cy="12" r="9" />
        </svg>
      );
  }
}

/**
 * Post-production vendor leg icons (cutting, finishing, border, needlework).
 */
export function VendorTripGlyph({ stage, className }) {
  const c = className || 'h-7 w-7';
  switch (stage) {
    case 'BUTTA_CUTTING':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M8 5l11 11M5 8l11 11" />
          <circle {...stroke} cx="7" cy="7" r="2" />
          <circle {...stroke} cx="17" cy="17" r="2" />
          <path {...stroke} d="M4 18l3-3" />
        </svg>
      );
    case 'MILL_FINISH':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M5 14c2-2 4-2 6 0s4 2 6 0M5 10c2-2 4-2 6 0s4 2 6 0M5 18c2-2 4-2 6 0s4 2 6 0" />
          <rect {...stroke} x="7" y="5" width="10" height="6" rx="1" />
        </svg>
      );
    case 'BORDER_CUTTING':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M7 7h4v4H7zM13 7h4v4h-4zM7 13h4v4H7zM13 13h4v4h-4z" />
          <rect {...stroke} x="9" y="9" width="6" height="6" rx="0.5" />
        </svg>
      );
    case 'HANDWORK':
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M12 4v14M12 18l-2 2M12 18l2 2" />
          <path {...stroke} d="M8 8c3 2 5 2 8 0" />
          <path {...stroke} d="M6 14c2 2 10 2 12 0" />
        </svg>
      );
    default:
      return (
        <svg className={c} viewBox="0 0 24 24" aria-hidden>
          <path {...stroke} d="M4 8h16v10H4zM8 8V6h8v2" />
        </svg>
      );
  }
}
